import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userName} from '../Univ.js'
function News() {
    const [newsview, setnewsview] = useState([]);
    const [newsData, setnewsData] = useState({
        heading: '',
        description: '',
        attachment: null,
        status: '',
        addedby: '',
        ip_add: '',
    });
    useEffect(() => {
        fetchmessData();
    }, []);
    function fetchmessData() {
        axios.get(baseUrl + "view-news/")
            .then(response => {
                setnewsview(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleMessChange = (event) => {
        setnewsData({
            ...newsData,
            [event.target.name]: event.target.value
        });
    }
    const handleFileChange = (event) => {
        setnewsData({
            ...newsData,
            attachment: event.target.files[0],
        });
    };
    const formSubmitmed = (e) => {
        e.preventDefault();
        const _formData = new FormData();
        if (newsData.attachment) {
            _formData.append('attachment', newsData.attachment);
        }
        _formData.append('heading', newsData.heading);
        _formData.append('description', newsData.description);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        axios.post(`${baseUrl}news-create/`, _formData, {
            headers: {"Content-Type": "multipart/form-data"}
        })
            .then(response => {
                Swal.fire({
                    title: 'News and Event Created.',
                    icon: 'success',
                    timer: 3000,
                    showConfirmButton: false
                });
                window.location.reload();
            })
            .catch(error => {
                Swal.fire('Error!', 'Failed to add news', 'error');
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-news/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-comment"
                aria-hidden="true" style={{color: 'red'}}></i> News and Events</h3>
            <div className="row mt-4">
                <form>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <tbody>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>Heading :</td>
                                <td>
                                    <input type="text" className="no-comma" name="heading" id="heading"
                                           value={newsData.heading}
                                           onChange={handleMessChange}/>

                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>News :</td>
                                <td>
             <textarea className="no-comma" tabIndex="0" name="description" id="description"
                       value={newsData.description}
                       onChange={handleMessChange}>
             </textarea>
                                </td>
                            </tr>

                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>File Upload :</td>
                                <td>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="attachment"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                    />

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
                </form>
            </div>
            <div className="row mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    View News and Events
                </h3>
                <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Heading</th>
                            <th>Description</th>
                            <th>File</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {newsview.map((newsviewData, index) => (
                            <tr>
                                <td>{newsviewData.heading}</td>
                                <td>{newsviewData.description}</td>
                                <td>
                                    <div>
                                        <a
                                            href={newsviewData.attachment}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={newsviewData.attachment}
                                                alt="Attachment"
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "300px",
                                                    height: "auto",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
                                                }}
                                            />
                                        </a>

                                    </div>
                                </td>
                                <td>
                                    <button onClick={() => handleDelete(newsviewData.id)}
                                            className="btn btn-danger btn-sm ms-1">
                                        <i className="fa-solid fa-trash-can"></i>Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    )
}
export default News;
